import React from 'react';
import IconBase from './IconBase';

const Experience = (props) => (
  <IconBase viewBox="0 -960 960 960" {...props}>
    <path d="M440-360h80v-120h120v-80H520v-120h-80v120H320v80h120v120ZM320-120v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z"/>
  </IconBase>
);


export default Experience;
